var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrackzerWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5574 16.1269L0 0C1.46885 0 3.51913 0.958711 4.36066 1.43807L13.3115 12.8399C14.2295 13.7438 15.4536 14.2437 15.9508 14.3807L35 17.1541L34.1967 17.565H13.082C11.8885 17.565 10.9016 16.6062 10.5574 16.1269Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9508 19.8248H32.8197C32.6361 20.1535 30.9071 21.2628 30.0656 21.7764L17.6721 22.5982C17.2131 22.5982 16.3333 23.4199 15.9508 23.8308L6.65574 34V33.1782L14 21.7764C14.7344 20.3795 15.6066 19.8933 15.9508 19.8248Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9016 20.6465L5.5082 12.8399L8.60656 19.8248C9.06557 20.6465 8.95082 21.5368 8.83607 21.8792L5.73771 27.8369C5.4623 28.6586 5.69945 29.8228 5.85246 30.3021L10.5574 23.1118C11.2918 21.9613 11.0929 20.9889 10.9016 20.6465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackzerWhite);
export default __webpack_public_path__ + "static/media/trackzer-white.8404495122cf318ab121435438c99004.svg";
export { ForwardRef as ReactComponent };